<div class="ng-hotel-tours-wrapper content-block">
    <div class="page-title">{{ isDesktopHotelsSearch ? 'Проживание в отеле ' : 'Туры в отель ' }}{{ hotelName }}</div>
    <app-short-search-params/>

    @if (isShowPriceCalendar && showStartHint) {
        <div class="calendar-start-hint">
            <div class="calendar-start-hint__icon"></div>
            <div class="calendar-start-hint__content">
                <div class="calendar-start-hint__title">Календарь цен поможет найти лучшие цены</div>
                <div class="calendar-start-hint__subtitle">Введите даты отдыха и ваш состав - мы покажем
                    календарь с лучшими ценами.
                </div>
            </div>
        </div>
    } @else if (isShowPriceCalendar && showPriceCalendar) {
        <app-hotel-price-calendar/>
    }

    @if (!showStartHint) {
        <app-hotel-tours/>
    }
</div>
